import { createReducer, on } from '@ngrx/store';
import { AccessControlListApiActions } from './user-group-acl.actions';
import { adapter, initialState } from './user-group-acl.state';

export const userGroupAclReducer = createReducer(
  initialState,
  on(AccessControlListApiActions.userGroupAclLoaded, (state, { userGroupAcl }) => adapter.addOne(userGroupAcl, state)),
  on(AccessControlListApiActions.userGroupAclMemberPut, (state, { aclMember }) =>
    adapter.updateOne(
      {
        id: aclMember.resourceId || 'Default-Group',
        changes: {
          users: (state.entities[aclMember.resourceId || 'Default-Group']?.users ?? []).map((x) =>
            x.member === aclMember.member ? aclMember : x
          ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.userGroupAclGroupPut, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId || 'Default-Group',
        changes: {
          groups: (state.entities[aclGroup.resourceId || 'Default-Group']?.groups ?? []).map((x) =>
            x.groupId === aclGroup.groupId ? aclGroup : x
          ),
        },
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectUserGroupAclIds = selectIds;
export const selectUserGroupAclsEntities = selectEntities;
export const selectAllUserGroupAcls = selectAll;
